export const SystemLang = "en";
